import { cn } from '@/lib/utils';
import { PhoneInput } from '@/components/ui/phone-input';

interface PhoneFormFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  helpText?: string;
  required?: boolean;
  disabled?: boolean;
  defaultCountry?: string;
  className?: string;
}

function PhoneFormField({
  label,
  value,
  onChange,
  error,
  helpText,
  required,
  disabled,
  defaultCountry,
  className,
}: PhoneFormFieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <label className="text-sm font-medium text-neutral-700">
        {label}
        {required && <span className="ml-0.5 text-error">*</span>}
      </label>
      <PhoneInput
        value={value}
        onChange={onChange}
        error={!!error}
        disabled={disabled}
        defaultCountry={defaultCountry}
      />
      {error && (
        <p className="text-sm text-error animate-fade-up" role="alert">
          {error}
        </p>
      )}
      {helpText && !error && <p className="text-sm text-neutral-500">{helpText}</p>}
    </div>
  );
}

export { PhoneFormField };
